var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_12984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76209 18.3413H0.921875C0.533562 18.3413 0.21875 18.6561 0.21875 19.0444V23.2969C0.21875 23.6852 0.533562 24.0001 0.921875 24.0001H6.46527V19.0444C6.46522 18.6561 6.15045 18.3413 5.76209 18.3413Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7114 14.4038H8.57422C8.18591 14.4038 7.87109 14.7186 7.87109 15.1069V24.0001H13.4145V15.1069C13.4145 14.7186 13.0997 14.4038 12.7114 14.4038Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3967 3.79734L23.8137 2.25938C24.0031 2.05406 24.0528 1.75641 23.9407 1.50094C23.8287 1.245 23.576 1.08 23.2967 1.08H18.7639V0.703125C18.7639 0.315 18.4494 0 18.0608 0C17.6727 0 17.3577 0.315 17.3577 0.703125V8.90625H15.5234C15.1351 8.90625 14.8203 9.22106 14.8203 9.60938V24H20.4832C20.8718 24 21.1864 23.685 21.1864 23.2969V9.60938C21.1864 9.22125 20.8718 8.90625 20.4832 8.90625H18.7639V6.39047H23.2967C23.5812 6.39047 23.8376 6.21891 23.9464 5.95594C24.0551 5.69297 23.9946 5.39016 23.7931 5.18953L22.3967 3.79734Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9322 6.03667C12.1048 6.38458 12.5265 6.5267 12.8745 6.3542C13.2224 6.18166 13.3646 5.75978 13.192 5.41188C11.9173 2.84139 12.0463 3.10052 12.0277 3.0656C11.8956 2.81594 11.6237 2.66519 11.3342 2.69519C11.3322 2.69538 11.3302 2.6958 11.3282 2.69603C11.2707 2.7025 11.4243 2.67236 8.76111 3.2328C8.3811 3.31277 8.13791 3.68566 8.21783 4.06567C8.28753 4.39685 8.57971 4.62414 8.90516 4.62414C9.00303 4.62414 8.93999 4.63225 10.1766 4.372C9.25457 6.18185 8.05452 7.83119 6.59722 9.28858C4.81114 11.0747 2.73599 12.475 0.429409 13.4506C0.0717532 13.6019 -0.0955437 14.0144 0.0557219 14.372C0.207081 14.73 0.619816 14.8969 0.977191 14.7458C3.45139 13.6993 5.67678 12.1978 7.59153 10.2829C9.15214 8.72233 10.438 6.95584 11.4265 5.0171L11.9322 6.03667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_12984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarr);
export default __webpack_public_path__ + "static/media/CARR.c1f6c52c2e3f29ed5461c277a92c1587.svg";
export { ForwardRef as ReactComponent };